import { render, staticRenderFns } from "./InquiryDetailHeader.vue?vue&type=template&id=dc95671a&scoped=true"
import script from "./InquiryDetailHeader.vue?vue&type=script&lang=js"
export * from "./InquiryDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./InquiryDetailHeader.vue?vue&type=style&index=0&id=dc95671a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc95671a",
  null
  
)

export default component.exports